import axiosConfig from '../utils/axiosConfigInstance';

const BASE = `${import.meta.env.VITE_APP_API_URL}/admin/featured-playlists`;

// verifyAdmin answers auth failures with HTTP 201 and a plain string, which axios treats
// as success. Turn that into a real error so the UI doesn't show "saved" when it wasn't.
const unwrap = async request => {
	const { data } = await request;
	if (typeof data === 'string') {
		const error = new Error(data);
		error.response = { data: { message: data } };
		throw error;
	}
	return data;
};

// Admin-only endpoints for managing featured playlists (backend: AdminFeaturedPlaylistRouter).
export const featuredPlaylistAdminApi = {
	list: async (q = '') => (await unwrap(axiosConfig.get(BASE, { params: q ? { q } : {} }))).playlists,
	get: async id => (await unwrap(axiosConfig.get(`${BASE}/${id}`))).playlist,
	create: payload => unwrap(axiosConfig.post(BASE, payload)),
	update: (id, payload) => unwrap(axiosConfig.put(`${BASE}/${id}`, payload)),
	remove: id => unwrap(axiosConfig.delete(`${BASE}/${id}`)),
	reorder: ids => unwrap(axiosConfig.put(`${BASE}/reorder`, { ids })),
	searchVideos: async (q = '', limit = 30) =>
		(await unwrap(axiosConfig.get(`${BASE}/videos/search`, { params: { q, limit } }))).videos
};

export const getApiErrorMessage = (error, fallback = 'Something went wrong') =>
	error?.response?.data?.message || error?.message || fallback;
